import React, { useEffect, useState, useRef, useCallback } from 'react';
import secureLocalStorage from 'react-secure-storage';
import {
  useGetLedgerQuery,
  useGetLedgerByIdQuery,
  useAddLedgerDataMutation,
  useUpdateLedgerDataMutation,
  useDeleteLedgerDataMutation
} from '../../../redux/ErpServices/Ledger.Services';
import FormHeader from '../../../Basic/components/FormHeader';
import FormReport from "../../../Basic/components/FormReportTemplate";
import { toast } from "react-toastify"
import { TextInput } from "../../../Inputs"
import ReportTemplate from '../../../Basic/components/ReportTemplate';
import PartyDropdown from '../../ReusableComponents/PartyDropdown';
import LedgerTypeDropdown from '../../ReusableComponents/LedgerTypeDropdown';

const MODEL = "Opening Balance";

export default function Form() {
  const [form, setForm] = useState(false);

  const [readOnly, setReadOnly] = useState(false);
  const [id, setId] = useState("")
  const [partyId, setPartyId] = useState("");
  const [amount, setAmount] = useState("");
  const [ledgerType, setLedgerType] = useState("");

  const [searchValue, setSearchValue] = useState("");

  const childRecord = useRef(0);

  const params = { companyId: secureLocalStorage.getItem(sessionStorage.getItem("sessionId") + "userCompanyId"), getData: true }
  const { data: allData, isLoading, isFetching } = useGetLedgerQuery({ params, searchParams: searchValue });
  const { data: singleData, isFetching: isSingleFetching, isLoading: isSingleLoading } = useGetLedgerByIdQuery(id, { skip: !id });

  const [addData] = useAddLedgerDataMutation();
  const [updateData] = useUpdateLedgerDataMutation();
  const [removeData] = useDeleteLedgerDataMutation();

  const syncFormWithDb = useCallback(
    (data) => {
      if (id) setReadOnly(true);
      setPartyId(data?.partyId ? data.partyId : "");
      setAmount(data?.amount ? data.amount : "");
      setLedgerType(data?.LedgerType ? data.LedgerType : "");
      childRecord.current = data?.childRecord ? data?.childRecord : 0;
    }, [id])


  useEffect(() => {
    syncFormWithDb(singleData?.data);
  }, [isSingleFetching, isSingleLoading, id, syncFormWithDb, singleData])


  const data = {
    partyId, amount, id, ledgerType
  }

  const validateData = (data) => {
    if (data.partyId && data.amount && data.ledgerType) {
      return true;
    }
    return false;
  }

  const handleSubmitCustom = async (callback, data, text) => {
    try {
      let returnData = await callback(data).unwrap();
      setId("")
      syncFormWithDb(undefined)
      toast.success(text + "Successfully");
    } catch (error) {
      console.log("handle")
    }
  }

  const saveData = () => {
    if (!validateData(data)) {
      toast.info("Please fill all required fields...!", { position: "top-center" })
      return
    }
    if (!window.confirm("Are you sure save the details ...?")) {
      return
    }
    if (id) {
      handleSubmitCustom(updateData, data, "Updated")
    } else {
      handleSubmitCustom(addData, data, "Added")
    }
  }

  const deleteData = async () => {
    if (id) {
      if (!window.confirm("Are you sure to delete...?")) {
        return
      }
      try {
        await removeData(id).unwrap();
        setId("");
        toast.success("Deleted Successfully");
      } catch (error) {
        toast.error("something went wrong")
      }
      ;
    }
  }

  const handleKeyDown = (event) => {
    let charCode = String.fromCharCode(event.which).toLowerCase();
    if ((event.ctrlKey || event.metaKey) && charCode === 's') {
      event.preventDefault();
      saveData();
    }
  }

  const onNew = () => { setId(""); setReadOnly(false); setForm(true); setSearchValue("") }

  function onDataClick(id) {
    setId(id);
    setForm(true);
  }
  const tableHeaders = [
    "Party", "Ledger", "Amount"
  ]
  const tableDataNames = ["dataObj?.Party?.aliasName", "dataObj?.LedgerType === 'Supplier' ? 'Purchase' : 'Sales'", "dataObj?.amount"]

  if (!form)
    return <ReportTemplate
      heading={MODEL}
      tableHeaders={tableHeaders}
      tableDataNames={tableDataNames}
      loading={
        isLoading || isFetching
      }
      setForm={setForm}
      data={allData?.data}
      onClick={onDataClick}
      onNew={onNew}
      searchValue={searchValue}
      setSearchValue={setSearchValue}
    />

  return (
    <div onKeyDown={handleKeyDown} className='md:items-start md:justify-items-center grid h-full bg-theme'>
      <div className='flex flex-col frame w-full h-full'>
        <FormHeader onNew={onNew} onClose={() => { setForm(false); setSearchValue(""); }} model={MODEL} saveData={saveData} setReadOnly={setReadOnly} deleteData={deleteData} />
        <div className='flex-1 grid grid-cols-1 md:grid-cols-4 gap-x-2 overflow-clip'>
          <div className='col-span-3 grid md:grid-cols-2 border overflow-auto'>
            <div className='mr-1 md:ml-2'>
              <fieldset className='frame my-1'>
                <legend className='sub-heading'>Info</legend>
                <div className='grid grid-cols-1 my-2'>
                  <PartyDropdown name={"Party"} multiSelect={false} withoutLabel={false} selected={partyId} setSelected={setPartyId} />
                  <LedgerTypeDropdown name={"Ledger Type "} multiSelect={false} withoutLabel={false} selected={ledgerType} setSelected={setLedgerType} />
                  <TextInput name="Amount" type="number" value={amount} setValue={setAmount} required={true} readOnly={readOnly} disabled={(childRecord.current > 0)} />
                </div>
              </fieldset>
            </div>
          </div>
          <div className='frame overflow-x-hidden'>
            <FormReport
              searchValue={searchValue}
              setSearchValue={setSearchValue}
              setId={setId}
              tableHeaders={tableHeaders}
              tableDataNames={tableDataNames}
              data={allData?.data}
              loading={
                isLoading || isFetching
              }
            />
          </div>
        </div>
      </div>
    </div>
  )
}
